import router from '../../shared/router';
import MenuService from '../../core/components/sidebar/MenuService';
import MenuItem from '../../core/components/sidebar/MenuItem';
import RecycleBinView from './RecycleBinView';

const {routes} = router.options;
const route = routes.find(r => r.name === 'app');

const tmpRoutes = [
  {
    path: 'recycle-bin',
    name: 'recycleBin',
    component: RecycleBinView,
  },

];

tmpRoutes.forEach((obj) => {
  route.children.push(obj);
});

router.addRoutes([route]);
// MenuService.addItem(new MenuItem('RecycleBin', {
//   path: '/app/recycle-bin',
//   text: 'Recycle Bin',
//   uuid: 'Recycle Bin',
//   permission: 'none',
//   weight: 100,
//   icon: ['fas', 'trash']
// }));
